<template>
  <el-card class="mangement-compontent">
    <div class="left">
      <el-tree
        :props="propsData"
        :load="loadNode"
        lazy
        show-checkbox
        node-key="id"
        @check="handleCheck">
      </el-tree>
    </div>
    <div class="right">
      <div class="search-content">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="searchForm.score" clearable placeholder="选择评价星级" @change="search">
              <el-option
                v-for="item in starList"
                :key="item.value"
                :label="item.text"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input clearable v-model="searchForm.userName" placeholder="人员姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select clearable v-model="searchForm.isCheck" placeholder="是否核验成功" @change="search">
              <el-option label="核验成功" value="1"></el-option>
              <el-option label="核验失败" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="dateTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleChangeTime">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="end" class="operation">
          <el-col :span="4">
            <div style="display: flex;justify-content: end;">
              <el-button type="primary" @click="search">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table-content">
        <el-table ref="dataTable" :data="tableData"  header-cell-class-name="table-header-cell"  border stripe>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="userName" label="姓名" width="120" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="confirmTime" label="时间" width="100" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="address" label="定位地址" min-width="280" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column label="评分" :show-overflow-tooltip="false">
            <template slot-scope="scope">
              <span v-if="scope.row.score == 0">未评分</span>
              <span v-else>{{scope.row.score}}星</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="评价" min-width="280" :show-overflow-tooltip="false">
            <template slot-scope="scope">
              <span v-if="scope.row.content ">{{scope.row.content}}</span>
              <span v-else>未评价</span>
            </template>
          </el-table-column>
          <el-table-column prop="department" label="部门" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="title" label="职位" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="region" label="管辖范围" width="280" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="photos" label="现场照片" min-width="100" align="center">
            <template slot-scope="scope">
              <span style="cursor: pointer;color: #1890ff;" v-if="scope.row.photos && scope.row.photos.length > 0" @click="viewImages(scope.row)">点击查看</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="delRecord(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" class="page">
          <el-col>
            <div style="display: flex; justify-content: end;">
              <el-pagination
                background 
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange"
                :current-page="searchForm.current" 
                :page-sizes="[10, 15, 30, 50]" 
                :page-size="searchForm.size"
                layout="total, sizes, prev, pager, next, jumper" 
                :total="totalData">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      append-to-body
      width="600px"
      :close-on-click-modal="false"
      title="现场图片"
      :visible.sync="imgModalVisible"
      @before-close="imgModalVisible = false">
      <div class="img-wrapper">
        <el-image 
          v-for="(item,index) in photosList"
          :key="index"
          style="width: 260px; height: 260px;margin-right: 10px;"
          :src="item" 
          :preview-src-list="[item]">
        </el-image>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import dayjs from 'dayjs'
import { getDeptLevle,getDeptSubsById,getRecord,delRecord,getRecordPhotos } from '@/api/index.js'
export default {
  name: 'CodeStatistcs',
  data() { 
    const startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'); 
    const endTime = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'); 
    return {
      dateTime:[startTime,endTime],
      searchForm: {
        current: 1,
        size: 10,
        isCheck:'1',
        beginTime:startTime,
        endTime:endTime,
      },
      propsData: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf'
      },
      tableData: [],
      totalData: 0,
      photosList: [],
      photoSrc: '',
      imgModalVisible: false,
    }
  },
  props: {
    stateValue: {
      type: Number,
      default: 0
    },
    starList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    stateValue(val) {
      if (val == 1) {
        this.search()
      }
    }
  },
  created() { 
    this.getTableData()
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        getDeptLevle(1).then(res => {
          if (res.code === '200') {
            let arr = []
            let d = res.result
            d.forEach(item => {
              arr.push({
                name: item.name,
                id:item.id
              })
            })
            return resolve(arr);
          }
        })
      } else { 
        getDeptSubsById(node.data.id).then(res => {
          if (res.code === '200') {
            let arr = []
            let d = res.result
            d.forEach(item => {
              arr.push({
                name: item.name,
                id:item.id
              })
            })
            return resolve(arr);
          }
        })
      }
    },
    handleChangeTime(v) { 
      if (v) {
        this.searchForm.beginTime = dayjs(v[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endTime = dayjs(v[1]).format('YYYY-MM-DD HH:mm:ss')
      } else { 
        this.searchForm.beginTime = ''
        this.searchForm.endTime = ''
      }
      this.search()
    },
    handleCheck(d,v) {
      let data = v.checkedNodes
      if (data.length === 0) {
        this.searchForm.deptIds = []
      } else { 
        this.searchForm.deptIds = []
        v.checkedNodes.forEach(item => {
          this.searchForm.deptIds.push(item.id)
        })
      }
      this.search()
    },
    search() {
      this.searchForm.current = 1
      this.getTableData()
    },
    async getTableData() { 
      for (let key in this.searchForm) { 
        if (this.searchForm[key] === '') { 
          delete this.searchForm[key]
        }
      }
      let res = await getRecord(this.searchForm)
      if (res.code === '200') { 
        this.tableData = res.result.records
        this.totalData = res.result.total
      }
    },
    handleSizeChange(v) { 
      this.searchForm.size = v
      this.getTableData()
    },
    handleCurrentChange(v) { 
      this.searchForm.current = v
      this.getTableData()
    },
    async viewImages(d) {
      let res = await getRecordPhotos(d.id)
      if (res.code === '200') {
        this.photosList = res.result.photos
        this.photoSrc = this.photosList[0]
        this.imgModalVisible = true;
      }
    },
    delRecord(d) { 
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRecord(d.id).then(res => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getTableData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped>
.mangement-compontent{
  text-align: left;
}
.mangement-compontent /deep/ .el-card__body {
  display: flex;
  justify-content: space-between;
}
.mangement-compontent .left{
  width: 260px;
  border-right: 2px solid #ddd;
}
.mangement-compontent .right{
  width: calc(100% - 280px);
}
.search-content {
  display: flex;
  justify-content: space-between;
}
.table-content .page {
  padding-top: 10px;
}
.img-wrapper {
  text-align: center;
}
</style>